import type { Grading } from "@memorang/types";

export const getMaximumScore = (
	grading: Grading | undefined,
): number | undefined => {
	if (!grading) {
		return undefined;
	}

	if (!grading.type) {
		return grading.maximumScore;
	}

	switch (grading.type) {
		case "binary":
			return grading.points ?? 1;

		case "selection": {
			if (grading.points) {
				return grading.points.max;
			}
			return grading.expectedResponses.reduce(
				(sum: number, response: { points: number }) => sum + response.points,
				0,
			);
		}

		case "form": {
			if (grading.points) {
				return grading.points.max;
			}
			return grading.expectedResponses.reduce(
				(sum: number, response: { points: number }) => sum + response.points,
				0,
			);
		}

		case "criteria":
			return Object.values(grading.criteria).reduce(
				(sum: number, criterion: { maxPoints: number }) =>
					sum + criterion.maxPoints,
				0,
			);

		case "points":
			return grading.totalPoints;

		default:
			return 0;
	}
};
